import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[350px] md:h-[450px] overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Horizontal%20ancient%20Chinese%20ink%20wash%20panoramic%20painting%2C%20vast%20mountain%20range%20with%20winding%20river%2C%20misty%20atmosphere%2C%20flying%20cranes%20in%20distance%2C%20soft%20ink%20green%20and%20warm%20grey%20tones%2C%20horizontal%20scroll%20composition%2C%20elegant%20and%20grand%2C%20minimalist%20with%20deep%20atmospheric%20perspective%2C%20silhouette%20pine%20trees&width=1920&height=900&seq=cta-bg-panorama&orientation=landscape"
          alt="加入古风漫画网"
          title="古风漫画网 - 立即开始阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-foreground-950/60" />

      {/* Content - triangular composition */}
      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6">
        {/* Top-left: Title */}
        <div className="absolute top-[25%] left-4 md:left-6">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 font-heading leading-none tracking-wide">
            即刻开启
          </h2>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 font-heading leading-none tracking-wide mt-2">
            古风之旅
          </h2>
        </div>

        {/* Bottom-left: CTA button */}
        <div className="absolute bottom-[20%] left-4 md:left-6">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-3 px-7 py-3.5 bg-background-50 text-foreground-950 rounded-full text-sm font-medium hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer"
          >
            <span>免费阅读</span>
            <span className="w-6 h-6 bg-foreground-950 rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-background-50 text-xs"></i>
            </span>
          </Link>
        </div>

        {/* Bottom-right: Description */}
        <div className="absolute bottom-[28%] right-4 md:right-6 max-w-xs">
          <p className="text-sm md:text-base text-background-50/70 font-light leading-relaxed text-right">
            数千部韩漫免费畅读
          </p>
          <p className="text-sm md:text-base text-background-50/70 font-light leading-relaxed text-right mt-1">
            每日更新，永不错过精彩
          </p>
        </div>
      </div>
    </section>
  );
}